<input #avatarPicker (change)="updatePhotoUrlForm($event)" accept="image/*" class="hidden"
       type="file">
@if (authService.user(); as user) {
  <div class="bg-white rounded-lg">
    <div class="p-8">
      <div class="grid grid-cols-2 gap-5">
        <div class="col-span-2 flex flex-col gap-4 md:flex-row place-content-between">
          <div class="-mt-16 relative">
            @if (form().get('photoURL')?.value; as url) {
              <img [src]="url"
                   alt="" class="w-24 h-24 border-white border-4 shadow-lg rounded-full object-cover" height="96"
                   width="96">
            } @else {
              <div
                class="font-bold text-gray-500 rounded-full bg-white flex items-center
                  justify-center text-2xl h-24 w-24 border-4 shadow-lg border-bleuCaliceo-300">
                {{ displayName().substring(0, 1) }}
              </div>
            }
            @if (edit()) {

              <button (click)="avatarPicker.click()"
                      (keyup.enter)="emulateClick($event)"
                      class="group absolute bottom-0 left-16 w-8 h-8 border-2 border-gray-500 hover:border-bleuCaliceo-300
                   bg-white shadow-lg rounded-full flex items-center justify-center">
                <svg class="w-5 h-5 stroke-gray-500 group-hover:stroke-bleuCaliceo-300" fill="none"
                     stroke="currentColor" stroke-width="1.5"
                     viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                    stroke-linecap="round"
                    stroke-linejoin="round"/>
                </svg>
              </button>
            }
          </div>
          <div [formGroup]="form()" class="flex flex-row gap-2 items-center">
            <div class="flex items-center mt-3">
              <input [value]="Gender.Male"
                     class="w-4 h-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                     formControlName="gender"
                     id="gender-male"
                     name="gender"
                     type="radio">
              <label class="ms-2 text-md font-medium text-gray-500"
                     for="gender-male">{{ 'mister' | translate }}</label>
            </div>
            <div class="flex items-center mt-3">
              <input [value]="Gender.Female"
                     class="w-4 h-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                     formControlName="gender"
                     id="gender-female"
                     name="gender"
                     type="radio">
              <label class="ms-2 text-md font-medium text-gray-500"
                     for="gender-female">{{ 'mrs' | translate }}</label>
            </div>
            <div class="flex items-center mt-3">
              <input [value]="Gender.Company"
                     class="w-4 h-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                     formControlName="gender"
                     id="gender-company"
                     name="gender"
                     type="radio">
              <label class="ms-2 text-md font-medium text-gray-500"
                     for="gender-company">{{ 'company' | translate }}</label>
            </div>
          </div>
        </div>
      </div>
      @if (!edit()) {
        <div class="md:grid grid-cols-2 gap-5 mt-7 font-semibold text-sm">
          <p>{{ displayName() }}<br>
            {{ user.address }}<br>
            {{ user.zip }} {{ user.city }}<br>
            {{ user.country }}
          </p>
          <p>
            {{ user.email }}<br>
            {{ user.phone }}
          </p>
        </div>
        <button (click)="enableEditProfile()"
                class="w-full mt-5 py-3 bg-beige hover:bg-gray-200 font-medium rounded-lg flex items-center justify-center gap-3 px-3 mb-8">
          {{ 'updateProfileInformation' | translate }}
          <svg class="h-4 w-4 fill-gray-500" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"/>
          </svg>
        </button>
        <div class="py-10 border-y border-gray-200">
          <p>{{ 'communicationPreference' | translate }}</p>
          <p class="text-sm">{{ 'communicationPreferenceMessage' | translate }}</p>
          <div class="flex gap-5 mt-3">
            <div [formGroup]="communicationForm()"
                 class="flex flex-col gap-2">
              <div class="grid grid-cols-3 gap-4 w-full">
                <span>{{ 'email' | translate }}</span>
                <label class="ms-2 text-base font-medium text-gray-500">
                  <input [value]="true"
                         class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                         formControlName="email"
                         id="notification-email"
                         type="radio">
                  {{ 'yes' | translate }}
                </label>
                <label class="ms-2 text-base font-monedium text-gray-500">
                  <input [value]="false"
                         class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                         formControlName="email"
                         id="notification-email"
                         type="radio">
                  {{ 'no' | translate }}
                </label>
                <span>{{ 'sms' | translate }}</span>
                <label class="ms-2 text-base font-medium text-gray-500">
                  <input [value]="true"
                         class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                         formControlName="sms"
                         id="notification-sms"
                         type="radio">
                  {{ 'yes' | translate }}
                </label>
                <label class="ms-2 text-base font-medium text-gray-500">
                  <input [value]="false"
                         class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                         formControlName="sms"
                         id="notification-sms"
                         type="radio">
                  {{ 'no' | translate }}
                </label>
                <span>{{ 'courrier' | translate }}</span>
                <label class="ms-2 text-base font-medium text-gray-500">
                  <input [value]="true"
                         class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                         formControlName="courrier"
                         id="notification-courrier"
                         type="radio">
                  {{ 'yes' | translate }}
                </label>
                <label class="ms-2 text-base font-medium text-gray-500">
                  <input [value]="false"
                         class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                         formControlName="courrier"
                         id="notification-courrier"
                         type="radio">
                  {{ 'no' | translate }}
                </label>
              </div>
              @if (!editCommunication()) {
                <button (click)="enableEditCommunication()"
                        class="underline cursor-pointer mt-4 md:mt-0"
                        tabindex="0">
                  {{ 'modify' | translate }}
                </button>
              } @else {
                @if (progress()) {
                  <div class="w-full overflow-hidden h-2 rounded-lg md:pl-10">
                    <div class='progress w-full h-1 bg-bleuCaliceo-300 left-right'></div>
                  </div>
                } @else {
                  <button [appProgressClick]="saveCommunicationPreference"
                          [disabled]="!communicationForm().valid"
                          class="underline cursor-pointer mt-4 md:mt-0 disabled:text-gray-400 disabled:cursor-default"
                          tabindex="0">
                    {{ 'save' | translate }}
                  </button>
                }
              }
            </div>
          </div>
        </div>
        @if (authService.user()?.hasPasswordLogin) {
          <div class="py-10 border-b border-gray-200">
            <p>{{ 'password' | translate }}</p>
            <p class="text-xs">{{ 'resetPassword' | translate }}</p>
            <button
              [appProgressClick]="resetPassword"
              class="w-full mt-5 py-3 bg-beige hover:bg-gray-200 font-medium rounded-lg flex items-center justify-center gap-3 px-3">
              {{ 'resetMyPassword' | translate }}
              <svg class="h-4 w-4 fill-gray-500" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"/>
              </svg>
            </button>
          </div>
        }
        <div class="py-10">
          <p>{{ 'deleteAccount' | translate }}</p>
          <p class="text-xs whitespace-pre-line">{{ 'deleteAccountDescription' | translate }}</p>
          <button
            (click)="drawerService.open({component: ConfirmDeleteAccountComponent, inputs: undefined, style: 'transparent'})"
            (keyup.enter)="emulateClick($event)"
            class="w-full mt-5 py-3 bg-beige hover:bg-gray-200 font-medium rounded-lg flex items-center justify-center gap-3 px-3">
            {{ 'deleteAccountButton' | translate }}
            <svg class="h-4 w-4 fill-gray-500" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"/>
            </svg>
          </button>
        </div>

      } @else {
        <div [formGroup]="form()" class="w-full pt-8">
          @if (user.shouldUpdateCenter) {
            <div class="mb-4">
              @if (centerService.center(); as siteCenter) {
                <div class="p-4 bg-gray-50 rounded-lg">
                  <p class="text-gray-700 font-semibold text-base">
                    {{ 'citySelectionTitle' | translate }} {{ siteCenter.name }}
                  </p>
                  <p class="text-gray-500 text-sm mt-1">
                    {{ 'citySelectionDescription' | translate }}
                  </p>
                  <p [innerHTML]="'otherCenterLink' | translate | byPass" class="text-gray-400 text-xs mt-2"></p>
                </div>
              } @else {
                <div appAutoClose="always" class="relative w-full">
                  <button aria-labelledby="centerChoice"
                          class="bg-gray-100 py-5 px-4 pr-10 md:px-7 disabled:bg-gray-200 hover:bg-gray-200 duration-200 cursor-pointer relative w-full rounded-md text-left text-gray-900 focus:outline-none"
                          type="button">
                    <span class="flex items-center">
                      <div class="w-12">
                        <img alt="{{'caliceoLocation' | translate}}" class="h-9 w-9 flex-shrink-0 m-auto" height="60"
                             ngSrc="assets/icons/gray/location.svg" width="60">
                      </div>
                      <span class="truncate text-gray-500 font-semibold text-lg ml-4 md:ml-6">
                        <p class="font-semibold truncate text-xs" id="centerChoice">
                          {{ 'centerSelectionQuestion' | translate }}
                        </p>
                        {{ centerService.withErpId(form().get('centerErpId')?.value ?? -1)?.name }}
                      </span>
                    </span>
                    <span class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-6">
                      <img alt="" class="h-4 w-4" height="60" ngSrc="assets/icons/gray/down.svg" width="60">
                    </span>
                  </button>
                  <ul
                    class="hidden absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                    role="listbox" tabindex="-1">
                    @for (center of activeCenters(); track center.id) {
                      <li (click)="form().get('centerErpId')?.setValue(center.erpId)"
                          (keyup.enter)="emulateClick($event)"
                          [attr.aria-selected]="form().get('centerErpId')?.value === center.erpId"
                          class="text-gray-900 hover:bg-gray-100 relative select-none py-4 px-3 md:px-5 cursor-pointer"
                          role="option"
                          tabindex="0">
                        <div class="flex items-center">
                          <span
                            [ngClass]="form().get('centerErpId')?.value === center.erpId ? 'font-semibold' : 'font-normal'"
                            class="text-lg text-gray-500 ml-3 block truncate">
                            {{ center.name }} @if (center.city; as city) {
                            - {{ city }}
                          }
                          </span>
                        </div>
                      </li>
                    }
                  </ul>
                  <p class="text-gray-500 text-sm mt-2">{{ 'centerSelectionDescription' | translate }}</p>
                </div>
              }
            </div>
          }
          <div>
            <div class="flex md:flex-row flex-col gap-4 mb-4">
              <div class="w-full md:w-1/2 mb-6 md:mb-0">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="firstName">
                  {{ 'firstName' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  class="appearance-none block w-full border-gray-200 text-gray-700 border rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white disabled:bg-gray-100"
                  formControlName="firstName"
                  id="firstName"
                  type="text">
              </div>
              <div class="w-full md:w-1/2">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="lastName">
                  {{ 'lastName' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                  formControlName="lastName"
                  id="lastName"
                  type="text">
              </div>
            </div>
            <div class="flex flex-wrap mb-4">
              <div class="w-full">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="birthDate">
                  {{ 'yourBirthday' | translate }} <span class="text-red-600">*</span>
                </label>
                <div class="flex gap-4" id="birthDate">
                  <select autocomplete="bday-day"
                          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                          formControlName="birthDay"
                          id="birthDay"
                          name="birthDay">
                    @for (day of days; track day) {
                      <option
                        [disabled]="!isValidDate(form().get('birthYear')!.value, form().get('birthMonth')!.value, day)"
                        [value]="day">{{ day }}
                      </option>
                    }
                  </select>
                  <select autocomplete="bday-month"
                          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                          formControlName="birthMonth"
                          id="birthMonth"
                          name="birthMonth">
                    @for (month of months; track month) {
                      <option
                        [disabled]="!isValidDate(form().get('birthYear')!.value, month, form().get('birthDay')!.value)"
                        [value]="month">{{ month }}
                      </option>
                    }
                  </select>
                  <select autocomplete="bday-year"
                          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                          formControlName="birthYear"
                          id="birthYear"
                          name="birthYear">
                    @for (year of years; track year) {
                      <option
                        [disabled]="!isValidDate(year, form().get('birthMonth')!.value, form().get('birthDay')!.value)"
                        [value]="year">{{ year }}
                      </option>
                    }
                  </select>
                </div>
              </div>
            </div>
            <div class="flex flex-wrap mb-4">
              <div class="w-full">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="address">
                  {{ 'address' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                  formControlName="address"
                  id="address"
                  type="text">
              </div>
            </div>
            <div class="flex flex-wrap mb-4">
              <div class="w-full">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="additionalAddress">
                  {{ 'additionalAddress' | translate }}
                </label>
                <input
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                  formControlName="additionalAddress"
                  id="additionalAddress"
                  type="text">
              </div>
            </div>
            <div class="flex md:flex-row flex-col gap-4 mb-4">
              <div class="w-full md:w-1/2 mb-6 md:mb-0">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="zip">
                  {{ 'zip' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  class="appearance-none block w-full border-gray-200 text-gray-700 border rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white disabled:bg-gray-100"
                  formControlName="zip"
                  id="zip"
                  type="text">
                @if (displayCities()) {
                  <div class="absolute z-10 flex w-screen max-w-min">
                    <div
                      class="w-56 shrink rounded-xl bg-white p-4 text-sm font-semibold leading-6 text-gray-900 shadow-lg ring-1 ring-gray-900/5">
                      @for (city of cities(); track city) {
                        <button (click)="setCity(city)" class="block p-2 hover:text-bleuCaliceo-400">{{ city }}</button>
                      }
                    </div>
                  </div>
                }
              </div>
              <div class="w-full md:w-1/2">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="city">
                  {{ 'city' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  (input)="setCity($any($event.target).value)"
                  [readOnly]="hasCityList()"
                  [value]="form().get('city')?.value"
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 read-only:bg-gray-100"
                  id="city"
                  type="text">
              </div>
            </div>
            <div class="flex flex-wrap mb-4">
              <label class="text-gray-500 text-md font-semibold pb-2 block" for="country">
                {{ 'country' | translate }} <span class="text-red-600">*</span>
              </label>
              <select autocomplete="country"
                      class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                      formControlName="country"
                      id="country"
                      name="country">
                @for (country of sortedCountries(); track country.libelle; ) {
                  <option [value]="country.libelle">{{ country.libelle }}</option>
                }
              </select>
            </div>
            <div class="flex flex-wrap mb-4">
              <div class="w-full">
                <app-tel-input [allowedCountries]="['BE', 'DE']" formControlName="phone"/>
                @if (form().get('phone')?.errors?.['pattern'] || form().get('phone')?.errors?.['mustBeE164']) {
                  <p class="peer-invalid:visible text-red-600 text-xs mt-2">
                    {{ 'phoneRules' | translate }}
                  </p>
                }
              </div>
            </div>
          </div>
        </div>
        <button [appProgressClick]="updateProfile"
                [disabled]="form().invalid"
                appHoverGradient
                class="flex items-center gap-3 my-6 w-full justify-center">
          {{ 'save' | translate }}
        </button>
      }
    </div>
  </div>
}
